import { parseFiniteNumber } from 'utils/parsingHelpers'

export enum PointCloudVisualizationType {
  ELEVATION = 'elevation',
  SOURCE = 'source',
}

export interface KVPointCloudVisualizationSettings {
  mode: PointCloudVisualizationType
  bottomColor: string
  topColor: string
  pointSize: number
  gapFillingStrength: number
}

export const DEFAULT_POINT_CLOUD_VISUALIZATION_SETTINGS: Readonly<KVPointCloudVisualizationSettings> =
  Object.freeze({
    mode: PointCloudVisualizationType.SOURCE,
    bottomColor: '#0040ff',
    topColor: '#ff1a00',
    pointSize: 1,
    gapFillingStrength: 0,
  })

export function normalizePointCloudVisualizationSettings(
  value: Partial<KVPointCloudVisualizationSettings> | null | undefined,
  fallback: KVPointCloudVisualizationSettings = DEFAULT_POINT_CLOUD_VISUALIZATION_SETTINGS
): KVPointCloudVisualizationSettings {
  const pointSize = parseFiniteNumber(value?.pointSize)
  const gapFillingStrength = parseFiniteNumber(value?.gapFillingStrength)
  const mode =
    value?.mode === PointCloudVisualizationType.ELEVATION ||
    value?.mode === PointCloudVisualizationType.SOURCE
      ? value.mode
      : fallback.mode

  return {
    mode,
    bottomColor:
      typeof value?.bottomColor === 'string'
        ? value.bottomColor
        : fallback.bottomColor,
    topColor:
      typeof value?.topColor === 'string' ? value.topColor : fallback.topColor,
    pointSize:
      pointSize !== undefined && pointSize >= 0 ? pointSize : fallback.pointSize,
    gapFillingStrength:
      gapFillingStrength !== undefined && gapFillingStrength >= 0
        ? gapFillingStrength
        : fallback.gapFillingStrength,
  }
}
